import { Button, Tooltip, Typography } from 'antd';
import { IoBookmarkSharp } from 'react-icons/io5';
import { useMemoSelector } from 'store/hooks';
import { useGetBibleUrlParams, useLanguage } from 'core/hooks';
import { getAuthState } from 'store/selectors/auth';
import Flex from 'components/common/Flex';
import { TRANSLATIONS_IDS_MAP } from 'config/constants';
import { useMemo } from 'react';

import { useReadingPageData } from '../useReadingPageData';

import BookNavigation from './BookNavigation';
import TranslationsSelector, { NOTES_VALUE } from './TranslationsSelector';

import '../style.scss';

function Header({
  onShowBookmarkDrawer,
}: {
  onShowBookmarkDrawer: () => void;
}) {
  const { translations } = useGetBibleUrlParams();
  const { userInfo } = useMemoSelector(getAuthState);
  const { readingData } = useReadingPageData();
  const { currentLanguage, langShortcut } = useLanguage();

  const chapter = useMemo(() => {
    const chapters = readingData?.chapters;
    if (!chapters?.length) return undefined;
    const translationIds = translations
      ?.split(',')
      .filter(part => part !== NOTES_VALUE)
      .map(Number)
      .filter(n => !Number.isNaN(n)) ?? [];
    const preferredId = TRANSLATIONS_IDS_MAP[langShortcut];
    const index = translationIds.indexOf(preferredId);
    return index >= 0 ? chapters[index] : chapters[0];
  }, [readingData, translations, langShortcut]);

  return (
    <header className="bible-v2-header">
      <Flex alignItems="center" gap={16} className="bible-v2-header__left">
        {userInfo?._id && (
          <Tooltip placement="bottom" title={currentLanguage.bookmarks}>
            <Button
              className="bible-navigation__bookmark-button"
              onClick={onShowBookmarkDrawer}
            >
              <IoBookmarkSharp />
            </Button>
          </Tooltip>
        )}
        <TranslationsSelector />
      </Flex>
      {chapter && (
        <Typography.Text className="bible-v2-header__chapter-title" ellipsis>
          {chapter.number}
          {chapter.title}
        </Typography.Text>
      )}
      <div className="bible-v2-header__right">
        <BookNavigation />
      </div>
    </header>
  );
}

export default Header;
